// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial_testimonial__jVNZy"};